import React from 'react';
import L from 'leaflet';
import { LayerGroup, LayersControl } from 'react-leaflet';
import WMSFeatureLayer from '../WMSFeatureLayer';
import { MapUtils } from '../../utils/MapUtils.jsx';

const { Overlay, } = LayersControl

export class BuildingLayers {

    static getMapLayers(t) {

        return (
            <Overlay name={t("map.buildingFootprints")}>
                <LayerGroup>
                <WMSFeatureLayer
                    key="building_footprints"
                    layer="building_footprints"
                    options={{
                        "format": "image/png",
                        "transparent": "true",
                        "info_format": "application/json",
                        'maxZoom': 21
                    }}
                    url='/maps/geodata/wms'
                    getPopupString={MapUtils.getBuildingPopupString}
                />
                </LayerGroup>
            </Overlay>
        );
    }
}